'use client'

import { cn } from '@utils'
import { useEffect, useRef, useState } from 'react'
import { CollapseContext, useCollapseContext } from './context'

export function Collapse({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLUListElement>) {
  return (
    <ul className={className} {...props}>
      {children}
    </ul>
  )
}

export function CollapseItem({
  header,
  headerClassName = '',
  headerActiveClassName = '',
  itemKey,
  children,
  className = '',
}: {
  header: React.ReactNode
  headerClassName?: string
  headerActiveClassName?: string
  itemKey: React.Key
  className?: string
  children: React.ReactNode
}) {
  const contentRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState<number>()
  const { currentKey, changeKey } = useCollapseContext()
  const isActive = currentKey === itemKey

  useEffect(() => {
    if (contentRef.current) {
      function handleResize() {
        setHeight(contentRef.current?.offsetHeight || 0)
      }
      // 初始化时设置高度
      handleResize()
      window.addEventListener('resize', handleResize)
      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [currentKey])

  function handleClick() {
    if (isActive) {
      // 如果当前索引已选中，则折叠
      changeKey(null)
    } else {
      // 否则展开当前CollapseItem
      changeKey(itemKey)
    }
  }
  return (
    <li className={cn('group/collapseItem', className, { active: isActive })}>
      <div
        className={cn(headerClassName, { [headerActiveClassName]: isActive })}
        onClick={handleClick}
      >
        {header}
      </div>
      <div
        className={cn(
          'transition-[height] origin-top duration-350 overflow-hidden'
        )}
        style={{ height: isActive ? `${height}px` : '0px' }}
      >
        <div ref={contentRef}>{children}</div>
      </div>
    </li>
  )
}

export function CollapseContextProvider({
  defaultKey = null,
  children,
}: {
  defaultKey?: React.Key | null
  children: React.ReactNode
}) {
  const [currentKey, changeKey] = useState<React.Key | null>(defaultKey)

  return (
    <CollapseContext.Provider value={{ currentKey, changeKey }}>
      {children}
    </CollapseContext.Provider>
  )
}
